import React, { useState, useEffect } from 'react';

const CompanySettings = () => {
  const [settings, setSettings] = useState({
    // Company Information
    companyName: '',
    companyTagline: '',
    companyAddress: '',
    companyPhone: '',
    companyEmail: '',
    companyWebsite: '',
    
    // Bank Details
    bankName: '',
    accountNumber: '',
    ifscCode: '',
    branch: '',
    gstNumber: '',
    
    // Terms & Conditions
    termsAndConditions: `1) Taxes extra as applicable.
2) Prices are Ex our Works.
3) Freight & transit insurance will be borned by customer.
4) Payment Terms : 100% Advance against proforma before delivery`,
    
    // Warranty
    warranty: `1) Warranty for the supplied equipment will be 6 months from date of invoice.
2) Spare & service back up within the warranty period is subjected to any manufacturing defect.
3) Warranty will be applicable only when supplied equipment is used with in the rated capacity and parameters.
4) Any rubber parts, electric equipment, oil seals, O rings, Wheels will not be covered under warranty.`,
    
    // Payment Terms
    paymentTerms: '100% Advance against proforma before delivery',
    
    // Tours & Travels - Inclusions/Exclusions Templates
    toursInclusions: `Accommodation (Hotel stay as per itinerary)
Daily Breakfast
Airport/Railway Station Transfers
All Sightseeing Tours with Guide
All Entrance Fees & Permits
All Applicable Taxes`,
    
    toursExclusions: `Airfare/Flight Tickets
Visa Fees & Processing
Travel Insurance
Personal Expenses (Laundry, Phone calls, etc.)
Lunch & Dinner (unless mentioned in itinerary)
Tips & Gratuities
Any items not mentioned in inclusions`,
    
    // Footer Information
    footerContactPerson: '',
    footerPhone: '',
    footerEmail: '',
    footerAddress: ''
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = () => {
    // Load from localStorage
    const savedSettings = localStorage.getItem('companyQuotationSettings');
    if (savedSettings) {
      setSettings(JSON.parse(savedSettings));
    }
  };

  const handleChange = (field, value) => {
    setSettings(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = () => {
    setLoading(true);
    try {
      // Save to localStorage
      localStorage.setItem('companyQuotationSettings', JSON.stringify(settings));
      
      setMessage({ type: 'success', text: '✅ Company settings saved successfully!' });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    } catch (error) {
      setMessage({ type: 'error', text: '❌ Error saving settings. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    if (window.confirm('Are you sure you want to reset to default settings?')) {
      localStorage.removeItem('companyQuotationSettings');
      loadSettings();
      setMessage({ type: 'info', text: 'ℹ️ Settings reset to default.' });
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    }
  };

  return (
    <div className="max-w-6xl mx-auto">
      <div className="bg-white rounded-lg shadow-lg p-6">
        {/* Header */}
        <div className="mb-6 pb-4 border-b-2 border-blue-600">
          <h2 className="text-3xl font-bold text-gray-800">🏢 Company Quotation Settings</h2>
          <p className="text-gray-600 mt-2">Configure your default quotation template information</p>
        </div>

        {/* Message */}
        {message.text && (
          <div className={`mb-6 p-4 rounded-lg ${
            message.type === 'success' ? 'bg-green-100 text-green-800 border-2 border-green-500' :
            message.type === 'error' ? 'bg-red-100 text-red-800 border-2 border-red-500' :
            'bg-blue-100 text-blue-800 border-2 border-blue-500'
          }`}>
            {message.text}
          </div>
        )}

        <div className="space-y-8">
          {/* Company Information */}
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-lg border-2 border-blue-200">
            <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
              <span className="text-2xl mr-2">🏢</span>
              Company Information
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Company Name *
                </label>
                <input
                  type="text"
                  value={settings.companyName}
                  onChange={(e) => handleChange('companyName', e.target.value)}
                  placeholder="FABTECH"
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Company Tagline
                </label>
                <input
                  type="text"
                  value={settings.companyTagline}
                  onChange={(e) => handleChange('companyTagline', e.target.value)}
                  placeholder="Manufacturer of Hydraulic Material Handling Equipment"
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Company Address *
                </label>
                <textarea
                  value={settings.companyAddress}
                  onChange={(e) => handleChange('companyAddress', e.target.value)}
                  placeholder="Plot No 34, G M Industrial Estate, Miraj 416410, Dist: Sangli MAHARASHTRA"
                  rows="2"
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Phone Number
                </label>
                <input
                  type="text"
                  value={settings.companyPhone}
                  onChange={(e) => handleChange('companyPhone', e.target.value)}
                  placeholder="+91 9011071740"
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email Address
                </label>
                <input
                  type="email"
                  value={settings.companyEmail}
                  onChange={(e) => handleChange('companyEmail', e.target.value)}
                  placeholder="marketing@kharefabbtek.com"
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>
          </div>

          {/* Bank Details */}
          <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-lg border-2 border-green-200">
            <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
              <span className="text-2xl mr-2">🏦</span>
              Bank Details
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Bank Name *
                </label>
                <input
                  type="text"
                  value={settings.bankName}
                  onChange={(e) => handleChange('bankName', e.target.value)}
                  placeholder="Central Bank of India"
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Account Number / CC AC No *
                </label>
                <input
                  type="text"
                  value={settings.accountNumber}
                  onChange={(e) => handleChange('accountNumber', e.target.value)}
                  placeholder="5501252606"
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  IFSC Code *
                </label>
                <input
                  type="text"
                  value={settings.ifscCode}
                  onChange={(e) => handleChange('ifscCode', e.target.value)}
                  placeholder="CBIN0282741"
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Branch
                </label>
                <input
                  type="text"
                  value={settings.branch}
                  onChange={(e) => handleChange('branch', e.target.value)}
                  placeholder="G M Industrial Estate, Miraj"
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  GST Number / GSTIN *
                </label>
                <input
                  type="text"
                  value={settings.gstNumber}
                  onChange={(e) => handleChange('gstNumber', e.target.value)}
                  placeholder="27AOZPK6478B1ZB"
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                />
              </div>
            </div>
          </div>

          {/* Terms & Conditions */}
          <div className="bg-gradient-to-r from-yellow-50 to-amber-50 p-6 rounded-lg border-2 border-yellow-200">
            <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
              <span className="text-2xl mr-2">📋</span>
              Terms & Conditions
            </h3>
            <textarea
              value={settings.termsAndConditions}
              onChange={(e) => handleChange('termsAndConditions', e.target.value)}
              rows="6"
              placeholder="Enter your terms and conditions..."
              className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 font-mono text-sm"
            />
            <p className="text-xs text-gray-600 mt-2">💡 Tip: Use numbered points for better readability</p>
          </div>

          {/* Payment Terms */}
          <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-6 rounded-lg border-2 border-purple-200">
            <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
              <span className="text-2xl mr-2">💳</span>
              Payment Terms
            </h3>
            <textarea
              value={settings.paymentTerms}
              onChange={(e) => handleChange('paymentTerms', e.target.value)}
              rows="3"
              placeholder="100% Advance against proforma before delivery"
              className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
            />
          </div>

          {/* Warranty */}
          <div className="bg-gradient-to-r from-red-50 to-orange-50 p-6 rounded-lg border-2 border-red-200">
            <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
              <span className="text-2xl mr-2">🛡️</span>
              Warranty Information
            </h3>
            <textarea
              value={settings.warranty}
              onChange={(e) => handleChange('warranty', e.target.value)}
              rows="6"
              placeholder="Enter warranty terms..."
              className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 font-mono text-sm"
            />
            <p className="text-xs text-gray-600 mt-2">💡 Tip: Include warranty period, coverage, and exclusions</p>
          </div>

          {/* Tours & Travels - Inclusions/Exclusions Templates */}
          <div className="bg-gradient-to-r from-green-50 to-teal-50 p-6 rounded-lg border-2 border-green-200">
            <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
              <span className="text-2xl mr-2">🎒</span>
              Tours & Travels - Default Templates
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  ✓ Inclusions (one per line)
                </label>
                <textarea
                  value={settings.toursInclusions}
                  onChange={(e) => handleChange('toursInclusions', e.target.value)}
                  rows="8"
                  placeholder="Accommodation&#10;Daily Breakfast&#10;Airport Transfers&#10;Sightseeing Tours"
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 font-mono text-sm"
                />
                <p className="text-xs text-gray-600 mt-2">💡 These will auto-fill in quotations</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  ✗ Exclusions (one per line)
                </label>
                <textarea
                  value={settings.toursExclusions}
                  onChange={(e) => handleChange('toursExclusions', e.target.value)}
                  rows="8"
                  placeholder="Airfare&#10;Visa Fees&#10;Travel Insurance&#10;Personal Expenses"
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 font-mono text-sm"
                />
                <p className="text-xs text-gray-600 mt-2">💡 Edit anytime before creating quotation</p>
              </div>
            </div>
          </div>

          {/* Footer Contact Information */}
          <div className="bg-gradient-to-r from-gray-50 to-slate-50 p-6 rounded-lg border-2 border-gray-200">
            <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
              <span className="text-2xl mr-2">📞</span>
              Footer Contact Information
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Contact Person Name
                </label>
                <input
                  type="text"
                  value={settings.footerContactPerson}
                  onChange={(e) => handleChange('footerContactPerson', e.target.value)}
                  placeholder="Hrishikesh Khare"
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Contact Phone
                </label>
                <input
                  type="text"
                  value={settings.footerPhone}
                  onChange={(e) => handleChange('footerPhone', e.target.value)}
                  placeholder="9011071740"
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Contact Email
                </label>
                <input
                  type="email"
                  value={settings.footerEmail}
                  onChange={(e) => handleChange('footerEmail', e.target.value)}
                  placeholder="marketing@kharefabbtek.com"
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Footer Address
                </label>
                <input
                  type="text"
                  value={settings.footerAddress}
                  onChange={(e) => handleChange('footerAddress', e.target.value)}
                  placeholder="Plot No 34, G M Ind Estate, Miraj 416410"
                  className="w-full p-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end space-x-4 mt-8 pt-6 border-t-2 border-gray-200">
          <button
            onClick={handleReset}
            className="px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600 font-medium transition-all shadow-md hover:shadow-lg"
          >
            🔄 Reset to Default
          </button>
          <button
            onClick={handleSave}
            disabled={loading}
            className="px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-all shadow-md hover:shadow-lg disabled:bg-blue-300"
          >
            {loading ? '⏳ Saving...' : '💾 Save Settings'}
          </button>
        </div>

        {/* Preview Note */}
        <div className="mt-6 p-4 bg-blue-50 border-2 border-blue-200 rounded-lg">
          <p className="text-sm text-blue-800">
            <strong>ℹ️ Note:</strong> These settings will be used as default values when generating new quotations. 
            You can still customize individual quotations when needed.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CompanySettings;
